import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  ogSiteName,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  canonicalUrl,
  twitterTitle,
  twitterSite,
  twitterDescription,
  twitterImage,
  twitterCard,
  geoRegion,
}) => {
  return (
    <HelmetProvider>
      <Helmet>
        {/* Standard Meta Tags */}
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />

        {/* Open Graph Meta Tags */}
        <meta property="og:site_name" content={ogSiteName} />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={ogUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content={twitterTitle} />
        <meta name="twitter:site" content={twitterSite} />
        <meta name="twitter:description" content={twitterDescription} />
        <meta name="twitter:image" content={twitterImage} />
        <meta name="twitter:card" content={twitterCard} />
        <meta name="geo.region" content={geoRegion} />

        {/* Additional Meta Tags */}
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
    </HelmetProvider>
  );
};

export default SEO;
